import { InjectionToken } from '@angular/core';

export const REQ_RES_WORKER = new InjectionToken<Worker>('Motion Master Req Res Worker Injection Token');
export const PUB_SUB_WORKER = new InjectionToken<Worker>('Motion Master Pub Sub Worker Injection Token');
export const LRSI_WORKER_FACTORY = new InjectionToken<Worker>('Motion Master LRSI Worker Factory Injection Token');
